export function mapTouched(data) {
  let exp = {}
  for (const d of data) {
    exp[`${d}Touched`] = false
  }
  return exp
}

export function mapRequired(fields) {
  let exp = {}
  for (const field of fields) {
    exp[`${field}Valid`] = function() {
      return this[field] !== '' && this[`${field}Touched`]
    }
    exp[`${field}Invalid`] = function() {
      return !this[field] && this[`${field}Touched`]
    }
  }

  return exp
}

export function mapEqual(fields) {
  let exp = {}
  for (const [k, v] of fields) {
    exp[`${k}EqualValid`] = function() {
      return this[k] === this[v] && this[`${k}Touched`]
    }
    exp[`${k}EqualInvalid`] = function() {
      return (this[k] !== this[v] || !this[k]) && this[`${k}Touched`]
    }
  }
  return exp
}

export function mapRequiredIf(fields, fn) {
  let exp = {}
  fields.forEach(field => {
    exp[`${field}IfValid`] = function() {
      return (
        this[`${field}Touched`] && !!this[field] && fn.bind(this)(this[field])
      )
    }
    exp[`${field}IfInvalid`] = function() {
      return (
        this[`${field}Touched`] && !!this[field] && !fn.bind(this)(this[field])
      )
    }
  })
  return exp
}

function getValue(ctx, keyOrFn) {
  // If it’s a string, read it from ctx
  if (typeof keyOrFn === 'string') {
    return ctx[keyOrFn]
  }
  // If it’s a function, call it (with 'ctx' as 'this' or pass 'ctx')
  if (typeof keyOrFn === 'function') {
    return keyOrFn.call(ctx)
  }
  return ''
}

export function mapValidateRegex(fields, regex) {
  let exp = {}
  fields.forEach(field => {
    exp[`${field}RegexValid`] = function() {
      return this[`${field}Touched`] && !!this[field] && regex.test(this[field])
    }
    exp[`${field}RegexInvalid`] = function() {
      return !(
        this[`${field}Touched`] &&
        !!this[field] &&
        regex.test(this[field])
      )
    }
  })
}

export function validationHelpers() {
  return {
    markAllTouched: function() {
      Object.keys(this.$data).forEach(k => {
        if (/Touched$/.test(k)) this[k] = true
      })
    },
    markAllNotTouched: function() {
      Object.keys(this.$data).forEach(k => {
        if (/Touched$/.test(k)) this[k] = false
      })
    },
  }
}

export function passwordValidators(password, username, firstName, lastName) {
  return {
    passwordLengthInvalid: function () {
      const pwdVal = getValue(this, password)
      // If there's nothing, return false or do your default condition
      if (!pwdVal) return false
      return pwdVal.length < 8 || pwdVal.length > 20
    },
    passwordUserNameInvalid: function() {
      const userName = getValue(this, username);
      const pwdVal = getValue(this, password)
      if(!userName || !pwdVal) return false;
      return (new RegExp(userName.toLowerCase())).test(pwdVal.toLowerCase())
    },
    passwordFirstLastNameInvalid: function() {
      const first = getValue(this, firstName);
      const last = getValue(this, lastName);
      const pwdVal = getValue(this, password);
      if(!first) return false;
      return (new RegExp(first.toLowerCase())).test(pwdVal.toLowerCase()) || 
              (new RegExp(last.toLowerCase())).test(pwdVal.toLowerCase())
    },
    passwordLowercaseInvalid: function() {
      const pwdVal = getValue(this, password)
      return !/[a-z]/.test(pwdVal)
    },
    passwordUppercaseInvalid: function() {
      const pwdVal = getValue(this, password)
      return !/[A-Z]/.test(pwdVal)
    },
    passwordNumeralInvalid: function() {
      const pwdVal = getValue(this, password) 
      return !/[0-9]/.test(pwdVal)
    },
    passwordSpecialInvalid: function() {
      const pwdVal = getValue(this, password)
      return /[+=]/.test(pwdVal) || !/[^A-Za-z0-9]/.test(pwdVal)
    },
    passwordTwoConsecutiveCharactersInvalid: function() {
      const pwdVal = getValue(this, password)
      return /(.)\1{2,}/.test(pwdVal)
    },
    passwordNineConsecutiveNumbersInvalid: function() {
      const pwdVal = getValue(this, password)
      return /\d{9}/.test(pwdVal)
    },
    passwordWhitespaceInvalid: function() {
      const pwdVal = getValue(this, password)
      return /\s/.test(pwdVal)
    },
    passwordAnyInvalid: function() {
     const pwdVal = getValue(this, password)
     if (!pwdVal) return false
      return (
        this.passwordLengthInvalid ||
        this.passwordUserNameInvalid ||
        this.passwordFirstLastNameInvalid ||
        this.passwordLowercaseInvalid ||
        this.passwordUppercaseInvalid ||
        this.passwordNumeralInvalid ||
        this.passwordSpecialInvalid ||
        this.passwordTwoConsecutiveCharactersInvalid ||
        this.passwordNineConsecutiveNumbersInvalid ||
        this.passwordWhitespaceInvalid
      )
    },
  }
}

export function phoneNumberValidators(phone, computedValueName = 'phoneFormatInvalid') {
  return {
    [computedValueName]: function(){
      return (
        !!this[phone] &&
        this[`${phone}Touched`] &&
        !this[phone].match(
          /^\d{10}$|^\d{3}[.-]\d{3}[.-]\d{4}$|^\(\d{3}\)\s?\d{3}[.-]?\d{4}$/,
        )
      )
    },
  }
}